export default "__VITE_ASSET__CbAi6ECw__"